module.exports = __webpack_public_path__ + "static/img/208.0d9e846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200518/208.jpg
// module id = r8Uw
// module chunks = 0